import AxiosClient from '@services/api/base'
import routes from '@configs/api'
import { Lecture } from '@ugu/types'
import { AUTH_TOKEN_KEY } from '@constants/localstorageKeys'
import Cookies from 'js-cookie'

/**
 * Delete Course Lecture
 * @param course_id
 * @param version
 * @param sectionId
 * @param lectureId
 */
const deleteCourseLecture = (
  course_id: string,
  version: number,
  sectionId: string,
  lectureId: string
): Promise<Lecture> => {
  return new Promise((resolve, reject) => {
    const tokenId = Cookies.get(AUTH_TOKEN_KEY)
    const URL =
      routes.COURSE +
      course_id +
      '/' +
      version +
      '/sections/' +
      sectionId +
      '/lectures/' +
      lectureId
    const config = {
      headers: {
        Authorization: `Bearer ${tokenId}`,
      },
    }

    AxiosClient.delete(URL, config)
      .then((res) => {
        resolve(res.data)
      })
      .catch((err) => {
        reject(err)
      })
  })
}

export default deleteCourseLecture
